import { createTypedHooks } from '@saniplus/api-client';

import type { AppDispatch, RootState } from './store';

export const { useAppDispatch, useAppSelector } = createTypedHooks<RootState, AppDispatch>();
